interface Props {
  fileSize: number;
  children: (formatted: string) => any;
}

const FileSize = ({ fileSize, children }: Props) => {
  if (fileSize >= 1024 * 1024 * 1024) {
    return children(`${(fileSize / 1024 / 1024 / 1024).toFixed(2)}GB`);
  } else if (fileSize >= 1024 * 1024) {
    return children(`${(fileSize / 1024 / 1024).toFixed(2)}MB`);
  } else if (fileSize >= 1024) {
    return children(`${(fileSize / 1024).toFixed(2)}KB`);
  }

  return children(`${fileSize} bytes`);
};

export default FileSize;
